(function () {
    'use strict';

    angular
        .module('app')
        .factory('CookiesService', CookiesService);

    CookiesService.$inject = ['$cookies'];
    function CookiesService($cookies) {

        var service = {
            saveCookie: saveCookie,
            getCookie: getCookie
        }

        return service;


        function saveCookie(name, value, expireHours = 1) {

            let expireDate = new Date();

            expireDate.setHours(expireDate.getHours() + expireHours)

            $cookies.put(name, value, { expires: expireDate });

        }

        function getCookie(name) {
            return $cookies.get(name);
        }



    }

})();